// Copied from js-angusj-clipper for compatiblity, but to avoid direct coupling to the library
// should we need flexiblity in future
export var EndType;
(function (EndType) {
    EndType["ClosedPolygon"] = "closedPolygon";
    EndType["ClosedLine"] = "closedLine";
    EndType["OpenButt"] = "openButt";
    EndType["OpenSquare"] = "openSquare";
    EndType["OpenRound"] = "openRound";
})(EndType || (EndType = {}));
export var JoinType;
(function (JoinType) {
    JoinType["Miter"] = "miter";
    JoinType["Round"] = "round";
    JoinType["Square"] = "square";
})(JoinType || (JoinType = {}));
//# sourceMappingURL=types.js.map